import signedFetch from './util/signedFetch.js';

export default (orgId, joiningCodeId, data) =>
  signedFetch(
    'editJoiningCode',
    `${__API_BASE__}/org/${encodeURIComponent(orgId)}/joining-codes/${encodeURIComponent(joiningCodeId)}`,
    'PUT',
    data
  );
